import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import { AnimatedChip, SVGIcon } from '@pearsontechnology/aero-components';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import {
  StyledButton,
  StyledParagraph,
  WrapperDiv,
  StyledChip,
  TextWrapper,
} from './styles';
import ImportInfoPopover from '../ImportInfoPopover';
import messages from './messages';
import { STATUS } from '../ImportList/constants';

const ImportProgressIndicator = (props) => {
  const {
    theme,
    ingestionStats,
    status,
    chipStatusColor,
    infoType,
    displayChip,
    courseName,
    ingestionId,
    ingestionStatsCount,
    ingestionType,
  } = props;
  const referenceNode = useRef();
  const [show, setShow] = useState();
  const onClicked = () => {
    setShow(!show);
  };

  const onClose = () => {
    setShow(false);
  };
  const showWarnings = !!(ingestionStatsCount &&
    (status === STATUS.COMPLETED.text || status === STATUS.FAILED.text));
  const iconColor = theme['color.orangeDark'];
  const iconType = 'warningCircle';

  return (
    <WrapperDiv>
      <div>
        {displayChip ? (
          <StyledChip
            green={chipStatusColor === 'green'}
            orange={chipStatusColor === 'orange'}
          >
            {status}
          </StyledChip>
        ) : (
          <AnimatedChip
            purple={chipStatusColor === 'purple'}
            blue={chipStatusColor === 'blue'}
            grey={chipStatusColor === 'grey'}
            animatedDots
            animationTime="10s"
            dotsAnimationTime="3s"
          >
            <TextWrapper>{status}</TextWrapper>
          </AnimatedChip>
        )}
        {!displayChip && (
          <StyledParagraph>
            {status !== STATUS.IMPORTING.text ? intl.formatMessage(messages.progressIndicator) : intl.formatMessage(messages.importingProgressIndicator) }
          </StyledParagraph>
        )}
      </div>
      {showWarnings && (
        <StyledButton
          show={show}
          ref={referenceNode}
          onClick={onClicked}
          iconOnly
          rounded
          flat
        >
          <SVGIcon fill={iconColor} size="medium" icon={iconType} />
        </StyledButton>
      )}
      {show && (
        <ImportInfoPopover
          referenceNode={referenceNode.current}
          infoType={infoType}
          show={show}
          ingestionStats={ingestionStats}
          onClose={onClose}
          courseName={courseName}
          ingestionId={ingestionId}
          showWarnings={showWarnings}
          ingestionType = {ingestionType}
        />
      )}
    </WrapperDiv>
  );
};

ImportProgressIndicator.propTypes = {
  ingestionStats: PropTypes.object,
  ingestionStatsCount: PropTypes.number,
  status: PropTypes.string,
  theme: PropTypes.object,
  chipStatusColor: PropTypes.string,
  infoType: PropTypes.string,
  displayChip: PropTypes.bool,
  courseName: PropTypes.string,
  ingestionId: PropTypes.string,
  ingestionType: PropTypes.string,
};

export default withTheme(ImportProgressIndicator);
